import React from "react";

import { IconProps } from "../../types/common/icons";

const PhoneIcon = ({
    width = "16",
    height = "16",
    style,
    className,
    fillClassName,
    fillColor = "#63696F",
}: IconProps) => (
    <svg 
        width={width} 
        height={height} 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path d="M12.8145 10.1789L11.1212 9.98554C10.7145 9.93887 10.3145 10.0789 10.0279 10.3655L8.8012 11.5922C6.91453 10.6322 5.36787 9.09221 4.40787 7.19887L5.6412 5.96554C5.92787 5.67887 6.06787 5.27887 6.0212 4.87221L5.82787 3.19221C5.74787 2.51887 5.1812 2.01221 4.5012 2.01221L3.34787 2.01221C2.59453 2.01221 1.96787 2.63887 2.01453 3.39221C2.36787 9.08554 6.9212 13.6322 12.6079 13.9855C13.3612 14.0322 13.9879 13.4055 13.9879 12.6522V11.4989C13.9945 10.8255 13.4879 10.2589 12.8145 10.1789Z" 
        fill={fillColor!} />
    </svg>
);

export default PhoneIcon;